import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';

const NewItemTypography = styled(KizenTypography)`
  color: var(--color-button-primary-default);
  &:hover {
    color: var(--color-button-primary-hover);
  }
  && {
    padding: 0;
    background: none;
    outline: none;
  }
`;

export default function NewItemButton(props) {
  return (
    <NewItemTypography
      as="button"
      weight="bold"
      size="buttonLabel"
      textTransform="uppercase"
      {...props}
    />
  );
}
